/**
 * Convert a string to an enum member which has the string as value.
 * Needed because Typescript doesn't support this reverse mapping. (https://www.typescriptlang.org/docs/handbook/enums.html#reverse-mappings)
 * @param value The string value of the enum.
 * @param enm The enum which would contain the value.
 * @returns If there is a corresponding value then returns the enum member, else return undefined.
 */
export const enumFromValue = <T>(value: string, enm: object): T | undefined =>
  Object.values(enm).find((v) => v === value);
